




































































































import { defineComponent, onMounted, reactive, ref } from '@vue/composition-api';
import SinglePage from '@components/SinglePage';
import request from '@/utils/request';
import { dialogObj, tipsDialog, closeDialog } from '@/useable/dialog';
import { isCore } from '@/useable/login';
import { Message } from 'element-ui';

export default defineComponent({
  name: 'Supply',
  components: { SinglePage },
  setup() {
    const tableLoading = ref(true);
    const ruleForm = ref(null);

    // 搜索表单配置
    const searchFormOptions = reactive({
      form: {
        supplierName: '',
        contact: '',
        cellPhone: '',
        workEmail: '',
        registerTime: '',
        inviteTime:'',
        registerStatus: '',
        isValid: '',
        approveStatus: '0'
      },
      formColumn: [
        {
          name: 'supplierName',
          type: 'input',
          label: '供应商名称：',
          disabled: false,
          placeholder: '输入供应商名称',
        },
        {
          name: 'contact',
          type: 'input',
          label: '联系人：',
          placeholder: '输入联系人姓名',
        },
        {
          name: 'cellPhone',
          type: 'input',
          label: '手机号：',
          placeholder: '输入联系人手机号',
        },
        {
          name: 'workEmail',
          type: 'input',
          label: '邮箱：',
          placeholder: '输入联系人邮箱',
        },
        {
          name: 'registerTime',
          type: 'date',
          label: '注册时间：',
          placeholder: '选择时间',
        },
        {
          name: 'inviteTime',
          type: 'date',
          label: '邀请时间：',
          placeholder: '选择时间',
        },
        {
          name: 'approveStatus',
          type: 'select',
          label: '审批状态：',
          placeholder: '选择审批状态',
          options: [
            {
              value: '3',
              name: '全部',
            },
            {
              value: '0',
              name: '待审批',
            },
            {
              value: '1',
              name: '已通过',
            },
            {
              value: '2',
              name: '已驳回'
            },
          ],
        },
        // {
        //   name: 'approveType',
        //   type: 'select',
        //   label: '审批类型：',
        //   placeholder: '选择审批类型',
        //   options: [
        //     {
        //       value: 'register',
        //       name: '供应商注册',
        //     },
        //     {
        //       value: 'transfer',
        //       name: '管理员转交',
        //     },
        //   ],
        // }
      ]
    });

    // 表格数据初始化
    const tableData = ref([]);
    const columns = ref([
      {
        label: '供应商名称',
        key: 'supplierName',
        width: 120
      },
      {
        label: '企业税号',
        key: 'supplierCertId',
        width: 140
      },
      {
        label: '联系人',
        key: 'contact',
      },
      {
        label: '手机号',
        key: 'cellPhone',
      },
      {
        label: '邮箱',
        key: 'workEmail',
      },
      {
        label: '审批类型',
        key: 'approveType',
        width: 110
      },
      {
        label: '审批状态',
        key: 'approveStatus',
        width: 100
      },
      {
        label: '驳回原因',
        key: 'operateDesc',
        width: 120
      },
      {
        label: '邀请时间',
        key: 'inviteTime',
        width: 120
      },
      {
        label: '注册时间',
        key: 'registerTime',
        width: 120
      },
    ]);

    // 分页数据
    const paginationOptions = reactive({
      size: 10,
      current: 1,
      total: 0,
    });

    // 手机号校验
    const validateNum = (rule, value, callback) => {
      const phone =
        /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
      if (!phone.test(value) && value) {
        callback(new Error('手机号格式不正确'));
      } else {
        callback();
      }
    };

    // 编辑表单校验
    const rules = {
      contact: [{ required: true, message: '请输入联系人', trigger: 'blur' }],
      contactPhone: [
        { required: true, message: '请输入手机号', trigger: 'blur' },
        { validator: validateNum, trigger: ['blur', 'change'] },
      ],
      contactEmail: [
        { required: true, message: '请输入工作邮箱', trigger: 'blur' },
        {
          type: 'email',
          message: '请输入正确的邮箱地址',
          trigger: ['blur', 'change'],
        },
      ],
    };

    // 格式化表单数据
    const defaultFormData = reactive({
      id: '',
      contact: '',
      contactPhone: '',
      contactEmail: '',
    });

    // 表单数据
    const dialogFormData = reactive({
      id: '',
      contact: '',
      contactPhone: '',
      contactEmail: '',
    });
    // const btnStatus = ref(true);

    // 获取表格数据方法
    const getTableData = async (queryParams) => {
      tableLoading.value = true;
      queryParams = Object.assign(queryParams, {approveStatus: queryParams.approveStatus || '3'});
      let res = await request('approve', 'registerApprovalList', queryParams);
      if (res?.code === 2000) {
        paginationOptions.total = res.data.total;
        paginationOptions.current = res.data.current;
        if (paginationOptions.current !== 1 && paginationOptions.current > Math.ceil(paginationOptions.total/paginationOptions.size)) {
          res = await request('approve', 'registerApprovalList', Object.assign(queryParams, {current: Math.ceil(paginationOptions.total/paginationOptions.size) || 1}));
          paginationOptions.total = res.data.total;
          paginationOptions.current = res.data.current;
        }
        tableData.value = res.data.records;
        tableLoading.value = false;
      }
    };

    const listCallback = async () => {
      await getTableData(Object.assign(searchFormOptions.form, {size: paginationOptions.size, current: paginationOptions.current}));
    };

    // 复选框选中值
    const multipleSelection = ref([]);

    // 是否能编辑邮箱
    const isEditMail = ref(false);

    // 数据表格配置
    const tableOptions = reactive({
      tableData,
      columns,
      showSelection: true,
      showEditColumn: true,
      btnsWidth: '210',
      tableLoading,
      getTableData,
      handleSelectionChange: (val) => {
        multipleSelection.value = val;
      }
    });

    // 打开编辑弹框
    const onEdit = (data) => {
      if (data.registerStatus==='0') {
        isEditMail.value=true;
      } else {
        isEditMail.value=false;
      }
      // btnStatus.value=true;
      dialogObj.type = 'edit';
      dialogObj.title = '编辑供应商信息';
      dialogObj.btnText = '保存';
      dialogFormData.id = data.id;
      dialogFormData.contact = data.contact;
      dialogFormData.contactPhone = data.cellPhone;
      dialogFormData.contactEmail = data.workEmail;
      dialogObj.state = true;
    };

    // 提交编辑
    const editSubmit = async (params) => {
      if (!isEditMail.value) {
        delete params.contactEmail;
      }
      const res = await request('supply', 'editSupplierInfo', params);
      if (res.code === 2000) {
        tipsDialog.showDialog = true;
        tipsDialog.text = '编辑已保存！';
        tipsDialog.icon = 'el-icon-success';
        tipsDialog.btns = ['confirm'];
        dialogObj.state = false;
      }
      listCallback();
    };

    const toggleAccount = async (type) => {
      if (!multipleSelection.value.length) {
        Message.error('请选择要通过的供应商');
        return;
      }

      if (!multipleSelection.value.every((item: any) => item.approveStatus === 0)) {
        Message.error('您选择的供应商中有已审批的供应商，请重新选择');
        return;
      }
      passInquiry(null);
      
    };

    const onPass = () => {
      dialogObj.type = 'pass';
      tipsDialog.text = '审批已通过';
      tipsDialog.icon = 'el-icon-success';
      tipsDialog.btns = ['confirm'];
      tipsDialog.showDialog = true;
    };

    const onReject = () => {
      dialogObj.type = 'reject';
      tipsDialog.text = '审批已驳回';
      tipsDialog.icon = 'el-icon-warning';
      tipsDialog.btns = ['confirm'];
      tipsDialog.showDialog = true;
    };

    // 通过询问
    const passInquiry = (row) => {
      dialogObj.type = 'pass';
      tipsDialog.text = '确定要审批通过吗？';
      tipsDialog.icon = 'el-icon-success';
      tipsDialog.btns = ['cancel', 'confirm'];
      tipsDialog.row = row;
      tipsDialog.showInquiryDialog = true;
    };

    // 驳回询问
    const rejectInquiry = (row) => {
      dialogObj.type = 'reject';
      tipsDialog.text = '确定要审批驳回吗？';
      tipsDialog.icon = 'el-icon-warning';
      tipsDialog.btns = ['cancel', 'confirm'];
      tipsDialog.row = row;
      tipsDialog.operateDesc = '';
      tipsDialog.showInquiryDialog = true;
    };

    const onApprove = async (type, row) => {
      let params: any = {
        supplierCertId: row.supplierCertId,
        contactMail: row.workEmail,
        approveStatus: type,
        approveType: row.approveType,
      };
      if (type === 2) {
        params = {
          ...params,
          operateDesc: tipsDialog.operateDesc,
        };
      }
      const res = await request('approve', 'approval', [params]);
      if (res.code === 2000) {
        tipsDialog.showInquiryDialog = false;
        if (type === 1) {
          // Message.success('成功通过');
          onPass();
        } else if (type === 2) {
          // Message.success('成功驳回');
          onReject();
        }
        listCallback();
      } else {
        Message.error(res.message);
      }
    };

    const onApproveBatch = async (type) => {
      const res = await request('approve', 'approval', 
        multipleSelection.value.map((item: any) => ({
          supplierCertId: item.supplierCertId,
          contactMail: item.workEmail,
          approveStatus: type,
          approveType: item.approveType,
        })),
      );

      if (res.code === 2000) {
        tipsDialog.showInquiryDialog = false;
        if (type === 1) {
          // Message.success('成功通过');
          onPass();
        }
        await listCallback();
      }
    };

    const onDownload = async (row) => {
      await request('approve', 'suppRegisterFileDownload', {
        supplierCertId: row.supplierCertId,
        contactMail: row.workEmail,
        approveType: row.approveType,
      });
    };

    onMounted(() => {
      listCallback();
    });

    return {
      searchFormOptions,
      tableOptions,
      paginationOptions,
      listCallback,
      // 页面数据&方法
      tipsDialog,
      isCore,
      toggleAccount,
      onEdit,
      dialogObj,
      dialogFormData,
      rules,
      closeDialog,
      defaultFormData,
      validateNum,
      editSubmit,
      // btnStatus,
      isEditMail,
      ruleForm,
      onApprove,
      onDownload,
      onPass,
      onReject,
      passInquiry,
      rejectInquiry,
      onApproveBatch,
    };
  }
});
